export const ArrowTo = () => {
    return (
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.5 3.18188C0.223858 3.18188 0 3.40574 0 3.68188C0 3.95803 0.223858 4.18188 0.5 4.18188L0.5 3.68188L0.5 3.18188ZM10.8536 4.03544C11.0488 3.84018 11.0488 3.52359 10.8536 3.32833L7.67157 0.146351C7.47631 -0.0489113 7.15973 -0.0489113 6.96447 0.146351C6.7692 0.341613 6.7692 0.658195 6.96447 0.853458L9.79289 3.68188L6.96447 6.51031C6.7692 6.70557 6.7692 7.02216 6.96447 7.21742C7.15973 7.41268 7.47631 7.41268 7.67157 7.21742L10.8536 4.03544ZM0.5 3.68188L0.5 4.18188L10.5 4.18188V3.68188V3.18188L0.5 3.18188L0.5 3.68188Z"
                fill="#979B98"
            />
        </svg>
    );
};
